module.exports = __webpack_public_path__ + "static/media/hero.27b5070d.jpg";